export function enable_form_after_callback(state = true, action) {
  if (action.type === 'ENABLE_SUBMITION') {
    return true;
  }
  if (action.type === 'DISABLE_SUBMITION') {
    return false;
  }
  return state;
}
